import { db } from '../firebase';
import { toast } from 'react-toastify';

const updateReports = (userId, reports) => {
  let error;
  const collectionRef = db.collection('users').doc(userId)
  try {
    collectionRef.update({ links: reports });
    toast.info("Reports successfully updated.");
  } catch (error) {
    console.log(error)
    toast.error("Error occured updating reports, view console.");
    
  }

  return { error };
}

export default updateReports;